/**
 * NotFound — Premium 404 page.
 */

import { Link } from "@tanstack/react-router";
import { Leaf } from "lucide-react";

export function NotFound() {
  return (
    <div className="flex min-h-[80vh] items-center justify-center px-5">
      <div className="max-w-md text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-secondary">
          <Leaf className="h-7 w-7 text-muted-foreground" strokeWidth={1.25} />
        </div>
        <p className="eyebrow mt-6">404</p>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl">This page has been repotted</h1>
        <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
          The page you're looking for doesn't exist or has been moved to a sunnier spot.
        </p>
        <div className="mt-10">
          <Link
            to="/"
            className="inline-flex min-h-12 items-center justify-center bg-primary px-10 text-xs tracking-[0.2em] text-primary-foreground uppercase transition-opacity hover:opacity-90"
          >
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
